import {Component, Inject} from '@angular/core';
import {ToasterConfig} from 'angular2-toaster';
import {APP_CONFIG_TOKEN, AppConfig} from '../../app.config';

@Component({
    selector: 'app-content',
    templateUrl: './content.component.html',
    styleUrls: ['./content.component.scss']
})
export class ContentComponent {

    toasterConfig: ToasterConfig;

    constructor(@Inject(APP_CONFIG_TOKEN) private readonly cfg: AppConfig) {
        this.toasterConfig = new ToasterConfig({
            animation: 'fade',
            positionClass: 'toast-top-center',
            limit: 1,
            tapToDismiss: true,
            showCloseButton: false,
            newestOnTop: true,
            timeout: cfg.toasterTimeout,
            mouseoverTimerStop: false
        });
    }
}
